import React from "react";
import { Link } from 'react-router-dom';
function refreshPage(){ 
  window.location.reload(); 
}
class footer extends React.Component {
  render() {
    return (
      <div>
         <br></br><br></br><br></br><br></br><br></br>
           
           <footer className="inner index-2">
        <div className="bottom">
          <div className="container">
            <div className="navigation">
              <ul>
                <li  onClick={refreshPage} ><Link to='/' >Home</Link></li>
  
                <li onClick={refreshPage}><Link to='/about' >About</Link></li>
               
                <li onClick={refreshPage}><Link to='/Services' >Services</Link></li>
               
              
                <li onClick={refreshPage}><Link to='/Portfolio' >Portfolio</Link></li>
               
                <li onClick={refreshPage}><Link to='/Career'  >Career</Link></li>
                
                <li onClick={refreshPage}><Link to='/Contact'  >Contact Us</Link></li>
              </ul>
            </div>
          </div>
          <hr />
          <div className="container">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 copyright">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12"> Copyright © 2019
                  <span className="separator-pipesign white" />
                  All Rights Reserved
                  <span className="separator-pipesign white" />
                  <a href="wizmen.net">Wizmen Systems</a> </div>
                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-right"> <a href="javascript:void(0)">Privacy Policy</a>
                  <span className="separator-pipesign white" />
                  <a href="javascript:void(0)">Terms &amp; Conditions</a>
                  <span className="separator-pipesign white" />
                  <a href="">FAQ's</a> </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      </div>
    );
  }
}

export default footer;
